export default __webpack_public_path__ + "static/bristolmyers-131f8fd2d9862c2a078d7c5a25f86243.svg";